interface Props {
  kind: 'impressum' | 'privacy';
  onBack: () => void;
}

export function LegalScreen({ kind, onBack }: Props) {
  return (
    <main className="mx-auto flex h-full w-full max-w-4xl flex-col overflow-y-auto px-6 py-8">
      <button type="button" onClick={onBack} className="btn-ghost mb-5 w-fit px-4 py-2">
        ← Zurück
      </button>

      {kind === 'impressum' ? <ImpressumBody /> : <PrivacyBody />}
    </main>
  );
}

function LegalContactCard() {
  return (
    <address className="not-italic rounded-xl border border-white/10 bg-white/5 p-4 text-sm text-white/80">
      <p className="mb-1 font-semibold text-white">Davut Dikme</p>
      <p>Dornbirner Str. 11</p>
      <p>70469 Stuttgart</p>
      <p>Deutschland</p>
      <p className="mt-2">
        <a href="tel:+491711768141" className="text-sys-yellow hover:brightness-110">
          +49 1711768141
        </a>
      </p>
      <p>
        <a href="mailto:info.ysddcues@gmail.com" className="text-sys-yellow hover:brightness-110">
          info.ysddcues@gmail.com
        </a>
      </p>
    </address>
  );
}

function ImpressumBody() {
  return (
    <section className="space-y-6 text-white/80">
      <header>
        <h1 className="text-3xl font-bold text-white">Impressum</h1>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold text-white">Unternehmen / Betreiber dieser Website</h2>
        <p className="font-semibold text-sys-yellow">
          Davut Dikme, handelnd unter YS&amp;DD Cues
        </p>
        <p>
          Diese Website wird von Davut Dikme als Einzelunternehmen unter der Geschäftsbezeichnung
          YS&amp;DD Cues betrieben. „Kleingewerbe“ bezeichnet den Gewerbestatus, ist aber keine eigene
          Rechtsform.
        </p>
        <LegalContactCard />
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">
          Umsatzsteuer / Preisangaben
        </h2>
        <p>
          Alle angegebenen Preise sind Endpreise (gemäß § 19 UStG wird keine Umsatzsteuer
          berechnet). Der Verkauf erfolgt individuell nach Absprache und wird persönlich per
          Abholung/Übergabe abgewickelt; ein Versand wird derzeit nicht angeboten.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">Online-Streitbeilegung</h2>
        <p>
          Wir sind weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen. Die EU-Plattform zur Online-Streitbeilegung
          wurde am 20. Juli 2025 eingestellt. Über diese Website übermittelte Bestellungen sind
          zunächst Anfragen; ein Vertrag kommt erst durch eine gesonderte Bestätigung des Betreibers
          zustande.
        </p>
      </section>
    </section>
  );
}

function PrivacyBody() {
  return (
    <section className="space-y-6 text-white/80">
      <header>
        <h1 className="text-3xl font-bold text-white">Datenschutzerklärung</h1>
        <p className="mt-1 text-sm text-white/50">
          Informationen zur Verarbeitung personenbezogener Daten gemäß Art. 13 DSGVO
        </p>
      </header>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">1. Verantwortlicher</h2>
        <p className="font-semibold text-sys-yellow">
          Davut Dikme, handelnd unter YS&amp;DD Cues
        </p>
        <p>
          Verantwortlicher für die Datenverarbeitung auf dieser Website im Sinne der
          Datenschutz-Grundverordnung (DSGVO) ist Davut Dikme, handelnd unter YS&amp;DD Cues
          als Einzelunternehmen.
        </p>
        <LegalContactCard />
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">2. Hosting &amp; Server-Logfiles</h2>
        <p>
          Beim Besuch dieser Website werden technisch notwendige Server-Logdaten verarbeitet (z.
          B. IP-Adresse, Zeitstempel, Browser/OS), um den Dienst bereitzustellen und die
          Systemsicherheit zu gewährleisten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">3. Cookies</h2>
        <p>
          Diese Website verwendet nur technisch notwendige Cookies (z. B. Spracheinstellungen) und
          setzt keine Tracking- oder Werbe-Cookies.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">4. Kontaktaufnahme</h2>
        <p>
          Bei Kontakt per E-Mail oder Telefon werden die von Ihnen übermittelten Daten nur zur
          Bearbeitung Ihrer Anfrage verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b bzw. f
          DSGVO.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-semibold text-white">5. Ihre Rechte</h2>
        <p>
          Sie haben nach DSGVO insbesondere das Recht auf Auskunft, Berichtigung, Löschung,
          Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch sowie ein
          Beschwerderecht bei einer Aufsichtsbehörde.
        </p>
      </section>
    </section>
  );
}
